import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { AvatarModule } from 'src/app/components/avatar/avatar.module';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { CustomerCreatePageRoutingModule } from './customer-create-routing.module';
import { CustomerCreatePage } from './customer-create.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AvatarModule,
    SharedPipesModule,
    CustomerCreatePageRoutingModule,
    NgxDatatableModule,
    NgxTippyModule,
  ],
  declarations: [CustomerCreatePage],
})
export class CustomerCreatePageModule {}
